import { jsx as _jsx } from "react/jsx-runtime";
import { ConversationsStaticFilter } from '../static/conversationsStaticFilter';
/** The list of directions conversations can be filtered by. */
const directions = [
    { id: 'inbound', name: 'Inbound' },
    { id: 'outbound', name: 'Outbound' },
    { id: 'internal', name: 'Internal' },
];
/** Represents the component for filtering the conversations by direction. */
export const ConversationsDirectionFilter = () => (_jsx(ConversationsStaticFilter, { type: "direction", items: directions }));
